import Index from './Index';
import Show from './Show';
import Update from './Update';
import {
  Switch,
  Route,
  useRouteMatch,
} from "react-router-dom";

let Combos = (props) => {
  let { path } = useRouteMatch();
  const theme = props.theme;

  return <>
    <Switch>
      <Route exact path={`${path}`}>
        <Index theme={theme} setShowMenu={props.setShowMenu} />
      </Route>
      <Route exact path={`${path}/detalhe/:customer_id`}>
        <Show theme={theme} />
      </Route>
      <Route exact path={`${path}/editar/:customer_id`}>
        <Update theme={theme} />
      </Route>
    </Switch>
  </>
}

export default Combos;
